// src/node_modules/@awesome.me/kit-63db24046b/icons/modules/kit/custom.mjs
var faVercel = {
  prefix: "fak",
  iconName: "vercel",
  icon: [
    512,
    512,
    [],
    "e00a",
    "M256 32L512 480 0 480 256 32z"
  ]
};
export {
  faVercel
};
